const SET_KEYWORD = "SET_KEYWORD";

export const setKeyword = (keyword) => ({
  type: SET_KEYWORD,
  keyword: keyword,
});
